(function () {
'use strict';

angular.module('hyresgastApp').controller('ListNegotiationOfficesCtrl', ListNegotiationOfficesCtrl);

function ListNegotiationOfficesCtrl(
  $location, $filter,
  Auth, ErrorHandler,
  User, Negotiation,
  CombinedNegotiationStates, NegotiationTypes, Limits
) {
  var vm = this;
  vm.statusChoices = Object.values(CombinedNegotiationStates).map(x => ({
    id: x,
    text: $filter('hyCombinedNegotiationStates')(x)
  }));
  vm.negotiationTypeChoices = Object.values(NegotiationTypes).map(x => ({
    id: x,
    text: $filter('hyNegotiationTypes')(x)
  }));
  vm.pageLimit = 30;
  vm.user = {};
  vm.tableColumns = [
    {
      title: 'Id',
      column: 'caseNumber'
    },
    {
      title: 'Namn',
      column: 'name'
    },
    {
      title: 'Organisation',
      column: 'counterpart.name'
    },
    {
      title: 'Förhandlingstyp',
      template: 'slot1',
      column: 'type',
      lookup: {
        idProperty: 'id',
        textProperty: 'text',
        dictionary: vm.negotiationTypeChoices,
        multi: true,
      },
    },
    {
      title: 'Kontor',
      column: 'office.name'
    },
    {
      title: 'Status',
      template: 'status',
      column: 'combinedState',
      lookup: {
        idProperty: 'id',
        textProperty: 'text',
        dictionary: vm.statusChoices,
        multi: true,
      },
    },
    {
      title: 'Begärt ändringsdatum',
      column: 'rentEffectiveFrom'
    },
    {
      title: 'Önskat datum för förhandling',
      column: 'callForNegotiation.negotiationDate'
    },
    {
      title: '',
      template: 'comment',
      filterType: 'none'
    }
  ];

  Auth.heartbeat().then(function () {
    getUserOffices();
  });

  function getUserOffices() {
    return User.get({
      id: Auth.currentUser().id
    })
      .$promise.then(function (response) {
        vm.user = response;
        // Convert response.offices object to an array for easily sorting and using length property
        var offices = [];
        for (var office in response.offices) {
          offices.push(response.offices[office]);
        }
        vm.user.offices = offices;
      })
      .catch(ErrorHandler('Misslyckades att hämta data.'))
      .finally(() => { vm.ready = true });
  }

  vm.gotoNegotiation = (negotiation) => {
    $location.search({});
    $location.path('/negotiations/' + negotiation.id);
  }

  let getParams = (includeProperties) => {
    let tableauParams = vm.lastParams;
    tableauParams.limit = Limits.InMemoryMiddleLimit;
    tableauParams.offset = 0;
    if (includeProperties) {
      tableauParams.includeProperties = includeProperties;
    }
    return tableauParams;
  };

  vm.getAllNegotiations = (cb, includeProperties) => {
    Negotiation.query(getParams(includeProperties), {})
      .$promise.then(function (data) { cb(data) });
  };

  vm.tableFGetData = params => {
    // eslint-disable-next-line no-undef
    return new Promise((resolve, reject) => {
      params.myOffices = 'true';
      Negotiation.query(params)
        .$promise.then(result => resolve(result))
        .catch(err => reject(err));
    });
  };
}
})();